import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import OrdersApiService from './_services/orders.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    order: {},
    orders: [],
    orderHistory: [],
    orderAttributes: [],
  },
  mutations: {
    [MutationTypes.SET_ORDER](state, payload) {
      state.order = payload;
    },
    [MutationTypes.SET_ORDERS](state, payload) {
      state.orders = payload;
    },
    [MutationTypes.SET_ORDER_HISTORY](state, payload) {
      state.orderHistory = payload;
    },
    [MutationTypes.SET_ORDER_ATTRIBUTES](state, payload) {
      state.orderAttributes = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_ORDER](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, id },
    ) {
      commit(MutationTypes.SET_ORDER, await OrdersApiService.getOrder({ suffix, id }));
    },
    async [ActionTypes.GET_ORDERS](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      commit(MutationTypes.SET_ORDERS, await OrdersApiService.getOrders({ suffix, ...rest }));
    },
    async [ActionTypes.GET_ORDER_HISTORY](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, id },
    ) {
      commit(
        MutationTypes.SET_ORDER_HISTORY,
        await OrdersApiService.getOrderHistory({ suffix, id }),
      );
    },
    async [ActionTypes.GET_ORDER_ATTRIBUTES](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, id },
    ) {
      commit(
        MutationTypes.SET_ORDER_ATTRIBUTES,
        await OrdersApiService.getOrderAttributes({ suffix, id }),
      );
    },
  },
};
